module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ad093676c5c19839d4e72ed843e2a281.png";